import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCustomerPageStore = defineStore('useCustomerPage', () => {
  const group = ref<Recordable[]>([])
  return {
    group
  }
})
